import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeMocks';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            探索韩漫分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            八大分类，海量资源，总有你喜欢的类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to="/category/all"
              className="group relative rounded-2xl overflow-hidden aspect-[1/1.1] cursor-pointer"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${cat.color}`}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="relative h-full flex flex-col items-center justify-center p-4 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mb-4">
                  <i className={`${cat.icon} text-3xl md:text-4xl text-foreground-950/70`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600/80">
                  {cat.count.toLocaleString()}部作品
                </p>
                <p className="text-xs text-foreground-500 mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}